module.exports = __webpack_public_path__ + "static/media/iPhoneXFlying.a4102147.png";